import { NavigationEnd } from "@angular/router";

export class RecordRouteNaviation {
    static readonly type = '[Router] Record route navigation event';

    constructor(public event: NavigationEnd) { }
}
